import * as React from "react"

import FullStructure from "./FullStructure"
import CondensedStructure from "./CondensedStructure"
import { IBreadcrumbInfo } from "../../index"

interface Props {
    sortedBreadcrumbs: IBreadcrumbInfo[]
    showCondensed: boolean
}

export const AbsoluteBreadcrumbs = ({
    sortedBreadcrumbs,
    showCondensed,
}: Props): JSX.Element =>
    showCondensed ? (
        <CondensedStructure sortedBreadcrumbs={sortedBreadcrumbs} />
    ) : (
        <FullStructure sortedBreadcrumbs={sortedBreadcrumbs} />
    )

export default AbsoluteBreadcrumbs
